"use strict";

/**
* Initializes the card with hover instance
* @param {Object} $root - the root element of the card with hover
*/
function initCardWithHoverInstance($root) {
    $root.on("click", function () {
        const $this = $(this);
        const $cardContent = $this.find(".js-card-content").length;
        if ($cardContent) {

            $this.find(".js-card-image-container").css("opacity", function (_, value) {
                return value === "0" ? "1" : "0";
            });

            $this.find(".js-card-content").css("opacity", function (_, value) {
                return value === "0" ? "1" : "0";
            });
        }
    });
}
/**
* Initializes the card with hover component
* @param {Object} $cards - jQuery object of the card with hover component
*/

{
    const $cards = $(".js-card-with-hover");

    $cards.each(function () {
        initCardWithHoverInstance($(this));
    });
}
